var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 6,
    transform: "rotate(-180 24 24)",
    fill: "none",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.00006C12.1317 8.9993 12.2621 9.02452 12.384 9.07429C12.5058 9.12405 12.6166 9.19738 12.7101 9.29006L16.7101 13.2901C16.8984 13.4784 17.0042 13.7338 17.0042 14.0001C17.0042 14.2664 16.8984 14.5218 16.7101 14.7101C16.5218 14.8984 16.2664 15.0042 16.0001 15.0042C15.7338 15.0042 15.4784 14.8984 15.2901 14.7101L12.0001 11.4101L8.71006 14.7001C8.51876 14.8639 8.27268 14.9495 8.02101 14.9398C7.76933 14.93 7.53059 14.8257 7.3525 14.6476C7.1744 14.4695 7.07007 14.2308 7.06035 13.9791C7.05063 13.7274 7.13623 13.4814 7.30006 13.2901L11.3001 9.29006C11.4863 9.10532 11.7377 9.00116 12.0001 9.00006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.fcc4425340fb9131e1d7cf428ade0e0f.svg";
export { ForwardRef as ReactComponent };